export default __webpack_public_path__ + "static/media/bv_hover.0fdcdca1.jpg";